import { gql } from "@apollo/client";
import { BlastRadiusFieldsFragmentDoc } from "../types";

export const GET_AGGREGATE_SCORES = gql`
  query GetAggregateScores(
    $entityMrn: String!
    $filter: AggregateScoreFilter
    $first: Int
    $after: String
    $last: Int
    $before: String
    $orderBy: AggregateScoreOrder
    $skipCases: Boolean = false
  ) {
    aggregateScores(
      entityMrn: $entityMrn
      filter: $filter
      first: $first
      after: $after
      last: $last
      before: $before
      orderBy: $orderBy
    ) {
      ... on AggregateScoresConnection {
        totalCount
        edges {
          cursor
          node {
            id
            iconId
            state
            effort
            enforcementState
            previewUntil
            manualEffort {
              totalManualEffort
              research
              scripting
              rollout
              verification
            }
            entity {
              ... on EntityInfoAsset {
                id
                mrn
                name
              }
              ... on EntityInfoSpace {
                id
                mrn
                name
                contacts {
                  contactType
                  identity
                  email
                  name
                }
              }
              ... on EntityInfoWorkspace {
                id
                mrn
                name
                contacts {
                  contactType
                  identity
                  email
                  name
                }
              }
              ... on EntityInfoOrganization {
                id
                mrn
                name
                contacts {
                  contactType
                  identity
                  email
                  name
                }
              }
            }
            findingMrn
            rank
            baseScore
            baseValue
            baseRating
            completion
            findingStats {
              pass
              total
            }
            riskValue
            rankScore
            scoreType
            rating
            blastRadius {
              ...BlastRadiusFields
            }
            epss {
              probability
              percentile
            }
            cvss {
              id
              value
              type
              vector
              source
              rating
            }
            riskFactors {
              mrn
              indicator
              title
              total
              affected
              isPositive
            }
            detectionSources {
              name
              firstDetectedAt
              lastUpdatedAt
              affectedAssets
              vendor
            }
            title
            description
            tags {
              key
              value
            }
            lastScannedAt
            firstDetectedAt
            remediatedAt
            spaceId
            spaceRiskImprovement
            openCases @skip(if: $skipCases) {
              totalCount
              edges {
                node {
                  status
                  mrn
                  createdAt
                  ticketRefs {
                    type
                  }
                }
              }
            }
            exception {
              id
              reviewStatus
              status
              action
              justification
              scope
              exceptionId
              exceptionMrn
              createdAt
              author {
                name
                mrn
                email
                type
              }
            }
            slaAtRiskCount
            slaOverdueCount
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
          hasPreviousPage
        }
      }
      ... on RequestError {
        message
        code
      }
      ... on NotFoundError {
        message
        code
      }
    }
  }
  ${BlastRadiusFieldsFragmentDoc}
`;
